export const pawelMurawski = {
    'firstName': 'Paweł',
    'lastName': 'Murawski',
    'mydrId': 'pawełmurawski',
    'profession': 'Psychoterapeuta w trakcie szkolenia',
    'avatar': 'pawel-murawski.webp',
    'slug': 'psychoterapeuta-pawel-murawski',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
    ]
}